import {
    Box,
    FormLabel,
    Switch,
    Text,
    useColorModeValue,
    useToast,
} from "@chakra-ui/react";
import PageCard from "../../../components/page-card";
import { translate } from "../../../i18n";
import { useElevatedAdminAccess } from "../hooks/useIsElevatedAdmin";
import { useSelectedOrganization } from "../hooks/useSelectedOrganization";
import { useUpdateOrganizationGameBookingCodeEnabled } from "../hooks/useUpdateOrganizationGameBookingCodeEnabled";

export default function GameBookingCodeSettingsCard() {
    const { selectedOrganization } = useSelectedOrganization();
    const { isElevated: isElevatedAdmin } = useElevatedAdminAccess();
    const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
    const toast = useToast();

    const enabled = selectedOrganization?.gameBookingCodeEnabled ?? false;

    const { mutate, isLoading } = useUpdateOrganizationGameBookingCodeEnabled(
        selectedOrganization?.id || '',
        () => {
            toast({
                title: translate('organization.game_booking_code_saved'),
                status: 'success',
                duration: 2000,
                position: 'top-right',
            });
        },
    );

    const handleToggle = (nextEnabled: boolean) => {
        if (!selectedOrganization) return;
        if (isLoading) return;
        mutate(
            { gameBookingCodeEnabled: nextEnabled },
            {
                onError: () => {
                    toast({
                        title: translate('error'),
                        status: 'error',
                        duration: 3000,
                        position: 'top-right',
                    });
                },
            },
        );
    };

    if (!selectedOrganization || !isElevatedAdmin) return null;

    return (
        <PageCard title={translate('organization.game_booking_code_title')}>
            <Box p={4}>
                <Box display="flex" alignItems="center" gap={3} mb={2}>
                    <Switch
                        isChecked={enabled}
                        isDisabled={isLoading}
                        onChange={(e) => handleToggle(e.target.checked)}
                        colorScheme="brand"
                        aria-label={translate('organization.game_booking_code_title')}
                    />
                    <FormLabel mb={0} color={textColorPrimary}>
                        {translate('organization.game_booking_code_title')}
                    </FormLabel>
                </Box>
                <Text fontSize="sm" color="gray.500">
                    {translate('organization.game_booking_code_helper')}
                </Text>
            </Box>
        </PageCard>
    );
}
